import React from "react";

const PlayIcon = ({ fill = "currentColor", size }) => {
  return (
    <svg
      id="playIcon"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      width={size}
      height={size}
      viewBox="0 0 17.5 21.2"
    >
      <path fill={fill} d="M0,0l17.5,10.9L0,21.2V0z" />
    </svg>
  );
};

export default PlayIcon;
